// import { Component, OnInit , Inject, Injectable } from '@angular/core';

// import { map, catchError } from 'rxjs/operators';
// import { SESSION_STORAGE, StorageService } from 'angular-webstorage-service';

// @Component({
//   selector: 'app-accessability',
//   templateUrl: './accessability.component.html',
//   styleUrls: ['./accessability.component.css']
// })
// @Injectable()

// export class AccessabilityComponent implements OnInit {
let STORAGE_KEY = "local_accessability";
//constructor(@Inject(SESSION_STORAGE) private storage: StorageService) { }

const accessabilities = {
  "underline-links": { selectors: "a", active: false },
  "high-contrast": {
    selectors:
      "body,table,tr,td,th,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font,div,p,span,section,a",
    active: false
  },
  "medium-contrast": {
    selectors:
      "body,table,tr,td,th,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font,div,p,span,section,a",
    active: false
  },
  monochrome: {
    selectors:
      "table,tr,td,th,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font,div,p,span,section,a",
    active: false
  },
  // "xl-font": {
  //   selectors:
  //     "table,tr,td,th,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font,div,p,span,section,a,input,textarea",
  //   active: false
  // },
  // "xxl-font": {
  //   selectors:
  //     "table,tr,td,th,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font,div,p,span,section,a,input,textrea",
  //   active: false
  // },
  "zoom-out": {
    selectors: "body",
    active: false
  },
  "zoom-in": {
    selectors: "body",
    active: false
  },
  "readable-font": {
    selectors:
      "table,tr,td,th,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font,div,p,span,section,a,input,textrea",
    active: false
  }
  // "stop-animations": {
  //   selectors:
  //     "table,tr,td,th,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font,div,p,span,section,a,input,textrea",
  //   active: false
  // }
};

//   ngOnInit() {
//     let sotredAccessabilities = JSON.parse(this.storage.get(this.STORAGE_KEY));
//     if (sotredAccessabilities == null) {
//       this.storage.set(this.STORAGE_KEY, JSON.stringify(this.accessabilities));
//     }else{
//       for (let style in sotredAccessabilities){
//         if(sotredAccessabilities[style].active == true){
//           this.toggleStyleSheet(style);
//         }
//       }
//     }

//   }

export const clearAllStyles = () => {
  for (let style in accessabilities) {
    accessabilities[style].active = false;
    let tags = accessabilities[style].selectors.split(",");
    document.getElementById(style).classList.remove("active");

    for (let index = 0; index < tags.length; index++) {
      let elements = document.querySelectorAll(
        tags[index] + ":not(.non-accessible)"
      ); //.querySelectorAll(tags[index]+":not(.non-accessible)");
      for (let elm = 0; elm < elements.length; elm++) {
        if (!elements[elm].classList.contains("non-accessible")) {
          elements[elm].classList.remove(style);
        }
      }
      elements = null;
    }
    STORAGE_KEY = JSON.stringify(accessabilities);
    //this.storage.set(STORAGE_KEY, JSON.stringify(this.accessabilities));
  }
};

export const toggleStyleSheet = stylesheet => {
  let currentlyActive = document.getElementsByClassName(stylesheet).length > 0;
  let tags = accessabilities[stylesheet].selectors.split(",");
  accessabilities[stylesheet].active = !currentlyActive;

  //toggle css class for the link
  //document.getElementById(stylesheet).classList.toggle("active");

  //document should be ready...
  setTimeout(() => {
    for (let index = 0; index < tags.length; index++) {
      let elements = document.querySelectorAll(
        tags[index] + ":not(.non-accessible)"
      ); //.querySelectorAll(tags[index]+":not(.non-accessible)");
      for (let elm = 0; elm < elements.length; elm++) {
        if (!elements[elm].classList.contains("non-accessible")) {
          if (!currentlyActive) {
            elements[elm].classList.add(stylesheet);
          } else {
            elements[elm].classList.remove(stylesheet);
          }
        } else {
          elements[elm].classList.remove(stylesheet);
        }
      }
      elements = null;
    }
    STORAGE_KEY = JSON.stringify(accessabilities);
  }, 500);
};

//   toggleMenu(){
//     document.getElementById('accessability-menu-container').classList.toggle('visible'); //accessability-menu-container
//     document.getElementById('accessability-menu-container').classList.toggle('hidden'); //accessability-menu-container
//   }
